import { render, staticRenderFns } from "./forks_button.vue.js?vue&type=template&id=4ade402e&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./forks_button.vue?vue&type=template&id=4ade402e&vue3"
import script from "./forks_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./forks_button.vue?vue&type=script&lang=js&vue3"
export * from "./forks_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./forks_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports